@if (ready) {
  <div style="height: 100%">
    @if (!navigationService.shownInIframe) {
      <nav-menu />
    }
    <div class="app-body" [ngClass]="{'in-iframe': navigationService.shownInIframe}">
      @if (!navigationService.shownInIframe) {
        <left-panel />
      }
      <router-outlet />
    </div>
    @if (!navigationService.shownInIframe) {
      <language-editor />
    }
    <coder-debug />
    <div class="overlay-container">
      <dropdown-list />
    </div>
    <status-messages />
  </div>
}
<div class="gorm-loader" [class.hidden]="ready" [class.error]="errors.length > 0">
  <img src="/assets/images/logo-white.svg" />
  @if (errors.length > 0) {
    <div class="error-list">
      @for (error of errors; track error) {
        <div>
          <strong>{{ error.name }}:</strong> {{ error.message }}
          @if (getDetailsString(error) != undefined) {
            <div class="error-details">{{ getDetailsString(error) }}</div>
          }
        </div>
      }
    </div>
  }
</div>
@if (navigationService.shownInIframe) {
  <icon type="arrow-up-right-from-square" (click)="openCurrentUrl()" class="break-out-of-frame" />
}
